import { render, staticRenderFns } from "./JjAuditDialog.vue?vue&type=template&id=160971c8&scoped=true"
import script from "./JjAuditDialog.vue?vue&type=script&lang=js"
export * from "./JjAuditDialog.vue?vue&type=script&lang=js"
import style0 from "./JjAuditDialog.vue?vue&type=style&index=0&id=160971c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160971c8",
  null
  
)

export default component.exports